<template>
  <el-form ref="ff" v-loading="loading" :model="formdata" label-width="80px">
    <el-form-item label="消息类型" required prop="Type">
      <el-radio-group v-model="formdata.Type">
        <el-radio v-for="item in typeOptions" :key="item.Code" :label="item.Code">{{ item.Name }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="收件人" required prop="Addressees">
      <el-tag v-for="item in Object.keys(formdata.Addressees)" :key="item" closable @close="removeUser(item)">{{ formdata.Addressees[item] }} </el-tag>
      <el-tag @click="pickStaffs" type="danger">员工+</el-tag>
      <el-tag @click="pickCustomers" type="danger">客户+</el-tag>
    </el-form-item>
    <el-form-item label="消息内容">
      <el-input v-model="formdata.Message" type="textarea" rows="10" />
    </el-form-item>
    <el-form-item>
      <uploader v-if="!loading" ref="uploader" :data="{ ObjectId: formdata.Id, Mode: 'message' }" multiple :auto-upload="false" accept=".jpg,.png,.xls,.xlsx,.pdf,.doc,.docx,.rar,.zip">
        <el-link slot="trigger" icon="el-icon-upload" size="small" type="primary">选取文件上传</el-link>
      </uploader>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit(true)">立即发送</el-button>
      <el-button type="info" @click="onSubmit(false)">保存草稿</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import staffPicker from "@/views/company/branch/staff/_picker"
import customerPicker from "@/views/company/customer/_user_picker"
export default {
  components: {
    uploader: () => import("@/views/system/file/multipleUpload"),
  },
  data () {
    return {
      loading: false,
      typeOptions: [],
      formdata: {
        Addressees: {}
      }
    }
  },
  created () {
    this.$apis.system.meta.itemList({ typeId: "message" }).then(res => {
      this.typeOptions = res
    }).catch(e => {
      this.$message.error(e)
    })
    this.loadData(this.$route.params?.id)
  },
  methods: {
    loadData (id) {
      if (!id || this.loading) {
        return
      }
      this.loading = true
      this.$apis.system.message.getInfo({
        id: id,
      }).then(res => {
        this.formdata = res
      }).finally(() => {
        this.loading = false
      })
    },
    //选择员工
    pickStaffs () {
      this.$layer.iframe({
        title: "选择员工",
        area: ['720px', '500px'],
        content: {
          content: staffPicker,
          parent: this,
          data: {
            multiple: true,
            callback: (res) => {
              res.forEach(element => {
                this.$set(this.formdata.Addressees, element.Id, element.Name)
              })
            }
          }
        }
      })
    },
    //选择客户
    pickCustomers () {
      this.$layer.iframe({
        title: "选择客户",
        area: ['720px', '500px'],
        content: {
          content: customerPicker,
          parent: this,
          data: {
            multiple: true,
            callback: (res) => {
              res.forEach(element => {
                this.$set(this.formdata.Addressees, element.User.Id, element.User.Name)
              })
            }
          }
        }
      })
    },
    //移除人员
    removeUser (key) {
      this.$delete(this.formdata.Addressees, key)
    },


    onSubmit (state = false) {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.$apis.system.message.submit({
            ...this.formdata,
            State: state
          }).then(id => {
            this.$set(this.formdata, "Id", id)
            return this.$refs.uploader.onSubmit(id)
          }).then(() => {
            this.$message({ message: "消息发送成功。", type: "success" })
            this.$router.replace({ path: `/message/detail/${this.formdata.Id}` })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  background: #fff;
  min-width: 720px;
  width: 72%;
  padding: 30px;
}
</style>
